module.exports = __webpack_public_path__ + "img/cf5225c584bb07780e3d8f5db2b764ae.png";